import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";
import { fmtDT } from "@/lib/brand";
import { Stars } from "@/components/site/Stars";

export default function AdminReviews() {
  const api = useApi();
  const [list, setList] = useState([]);
  const load = useCallback(() => {
    api.get("/admin/reviews").then((r) => setList(r.data));
  }, [api]);
  useEffect(() => {
    load();
  }, [load]);
  const toggle = async (r) => {
    try { await api.patch(`/admin/reviews/${r.id}`, { hidden: !r.hidden }); toast.success(r.hidden ? "Review shown" : "Review hidden"); load(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-6" data-testid="admin-reviews">
      <h1 className="text-3xl font-semibold tracking-tight">Reviews <span className="text-neutral-500">({list.length})</span></h1>
      <div className="overflow-x-auto rounded-lg border border-white/10 bg-[#141414]">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-wider text-neutral-500">
            <tr>{["Car", "Customer", "Rating", "Comment", "Date", ""].map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {list.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-neutral-500" data-testid="reviews-empty">No reviews yet.</td></tr>}
            {list.map((r) => (
              <tr key={r.id} className={r.hidden ? "opacity-50" : ""} data-testid={`admin-review-${r.id}`}>
                <td className="px-4 py-3">{r.car_name}</td>
                <td className="px-4 py-3">{r.name}<p className="text-xs text-neutral-500">{r.booking_id}</p></td>
                <td className="px-4 py-3"><Stars value={r.rating} /></td>
                <td className="max-w-sm px-4 py-3 text-xs text-neutral-300">{r.comment || "—"}</td>
                <td className="px-4 py-3 text-xs text-neutral-400">{fmtDT(r.created_at)}</td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => toggle(r)} data-testid={`admin-review-toggle-${r.id}`} className={`rounded-md px-3 py-1 text-xs font-semibold ${r.hidden ? "bg-emerald-600 text-white" : "bg-white/10 text-neutral-200 hover:bg-rose-600"}`}>{r.hidden ? "Show" : "Hide"}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
